module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page greyBg"
  }, [_c('pageTitle', {
    attrs: {
      "title": "储值卡充值"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "usermes whiteBg"
  }, [_c('inputBox', {
    attrs: {
      "label": "会员姓名",
      "disabled": true,
      "hintMsg": "会员姓名",
      "value": _vm.userName
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "label": "会员卡号",
      "disabled": true,
      "hintMsg": "会员卡号",
      "value": this.userInfo.Card_no
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "label": "手机号码",
      "disabled": true,
      "hintMsg": "手机号码",
      "value": this.userInfo.sjno
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "recommend whiteBg"
  }, [_c('div', {
    staticClass: "radioArea",
    on: {
      "click": _vm.changeRecommend
    }
  }, [_c('radioBtn', {
    attrs: {
      "value": _vm.recommend
    }
  }), _vm._v("\n          员工推荐储值\n        ")], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.recommend) ? _c('div', [_c('inputBox', {
    attrs: {
      "label": "酒店编号",
      "disabled": _vm.fromUrl,
      "hintMsg": "请输入酒店编号"
    },
    model: {
      value: (_vm.hotelCode),
      callback: function($$v) {
        _vm.hotelCode = $$v
      },
      expression: "hotelCode"
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "label": "员工卡号",
      "disabled": _vm.fromUrl,
      "hintMsg": "请输入员工卡号"
    },
    model: {
      value: (_vm.employeeCode),
      callback: function($$v) {
        _vm.employeeCode = $$v
      },
      expression: "employeeCode"
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "money whiteBg"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("充值金额")]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('div', {
    class: {
      selected: _vm.money == '300'
    },
    on: {
      "click": function($event) {
        _vm.money = '300'
      }
    }
  }, [_c('h3', [_vm._v("300元")]), _vm._v(" "), _c('small', [_vm._v("送300K币")])]), _vm._v(" "), _c('div', {
    class: {
      selected: _vm.money == '500'
    },
    on: {
      "click": function($event) {
        _vm.money = '500'
      }
    }
  }, [_c('h3', [_vm._v("500元")]), _vm._v(" "), _c('small', [_vm._v("送500K币")])]), _vm._v(" "), _c('div', {
    class: {
      selected: _vm.money == '1000'
    },
    on: {
      "click": function($event) {
        _vm.money = '1000'
      }
    }
  }, [_c('h3', [_vm._v("1000元")]), _vm._v(" "), _c('small', [_vm._v("送1000K币")])])]), _vm._v(" "), _c('span', {
    staticClass: "title other"
  }, [_vm._v("其他金额（单位：元）")]), _vm._v(" "), _c('mu-auto-complete', {
    attrs: {
      "fullWidth": "",
      "hintText": "3000",
      "type": "number"
    },
    model: {
      value: (_vm.money),
      callback: function($$v) {
        _vm.money = $$v
      },
      expression: "money"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "radioArea"
  }, [_c('radioBtn', {
    attrs: {
      "value": true
    }
  }), _vm._v("\n          消费时开发票\n        ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rule whiteBg"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("充值条款：")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            1.请核对会员账户信息、充值金额、充值成功后无法取消、退款。"), _c('br'), _vm._v("\n            2.关于充值优惠、发票、使用说明等会员储值细则请点击查看"), _c('router-link', {
    attrs: {
      "to": "/wallet/valueCardRule"
    }
  }, [_vm._v("[查看储值优惠政策及使用规则]")]), _vm._v("，确认后再充值。"), _c('br'), _vm._v(" "), (_vm.fromUrl || _vm.recommend) ? _c('span', [_vm._v("3.酒店编号：" + _vm._s(_vm.hotelCode) + "  员工卡号：" + _vm._s(_vm.employeeCode))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "radioArea",
    on: {
      "click": _vm.changeAgree
    }
  }, [_c('radioBtn', {
    attrs: {
      "value": _vm.agreeState
    }
  }), _vm._v("\n          我同意上述条款\n        ")], 1), _vm._v(" "), _c('mu-raised-button', {
    style: ({
      width: '90%',
      height: '50px',
      margin: '20px 5%'
    }),
    attrs: {
      "primary": "",
      "label": '充值' + _vm.money + '元'
    },
    on: {
      "click": _vm.post
    }
  })], 1), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "id": "alertline",
      "message": _vm.hintMsg
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b9e5b32c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wallet/recharge.vue
// module id = 1584
// module chunks = 18